<template>
  <div class="container fluid">
    <v-card>
      <v-toolbar
        dark
        tabs
        flat
        class="toolbar white--text"
      >
        <v-toolbar-title class="justify-center">
          <h1 class="display-1 headline text--accent-1">
            Report Finanzportfolioverwaltung
          </h1>
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-toolbar
        dark
        tabs
        flat
        height="72px"
        class="toolbar"
      >
        <v-tabs
          v-model="tab"
          slider-color="amber"
          grow
          centered
          icons-and-text
        >
          <v-tab
            v-for="(item, id) in tabs"
            :key="id"
            class="toolbar"
            :href="`#${id}`"
          >
            <span>{{ item.title }}</span>
            <v-icon>{{ item.icon }}</v-icon>
          </v-tab>
        </v-tabs>
      </v-toolbar>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="(item, id) in tabs"
          :key="id"
          :value="`${id}`"
        >
          <v-card flat>
            <component
              :is="item.component"
            />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { OpenFpvReportsTab, ApprovedFpvReportsTab } from '@/components/roboInvesting';

export default {
  name: 'RoboInvestingFpvReports',
  components: {
  },
  data() {
    return {
      tab: null,
      tabs: {
        Preview: {
          title: 'Open',
          icon: 'check_box',
          component: OpenFpvReportsTab,
        },
        Approved: {
          title: 'Approved',
          icon: 'verified_user',
          component: ApprovedFpvReportsTab,
        },
      },
    };
  },
};
</script>

<style lang="scss">
.toolbar {
  background-color: #1a4c7d !important;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/roboInvesting/RoboInvestingFpvReports.vue